import { useCallback } from "react";
import { callApi } from "../api/callApi";
import { API_ENDPOINT, API_URL } from "../api/constant";

const useOrderApi = () => {
    const downloadInvoice = useCallback(async (orderId: string) => {
        try {
            const response: any = await callApi(
                `${API_URL}${API_ENDPOINT.order}orders/invoice/${orderId}`,
                { method: "GET" }
            );

            // Open a new window to print the invoice
            const printWindow = window.open("", "_blank", "width=800,height=900");
            if (printWindow) {
                printWindow.document.open();
                printWindow.document.write(response);
                printWindow.document.close();
                printWindow.print(); // Opens print dialog
            }

        } catch (error: any) {
            console.error("Error fetching order invoice:", error.message);
        }
    }, []);

    return { downloadInvoice };
};

export default useOrderApi;
